<template>
    <div class="mt-4">
        <section-title has-line :title="title" /> 
          <collapsible-section
                icon-class="fas fa-search"
                title="Búsqueda" 
                :opened="true"       
            >                       
            <div class="row">
                <div class="col">
                <filter-manager
                    :display-advanced="false"
                    class="bg-secondary-3"
                    items-container-class="flex-wrap"
                    search-icon="fa fa-search"
                    search-text="Buscar"
                    search-container-class="btn-md-process"
                    v-model="filters"
                    :filters="filterManagerConfig"
                    @search="$emit('on-search')"
                    ref="filterRef"
                />
                </div>
            </div>
          </collapsible-section>
          
            <div class="d-flex justify-content-end align-items-center actions text-right py-3"> 
              <a class="text-orange" href="#" @click="$emit('on-print')">
                  <i class="fas fa-print pr-1" />
                  <span>Imprimir Detalle</span>
              </a>      
            </div>

            <slot></slot>
         
            <div v-if="data.result.length == 0" class="row pt-3">
                <div class="col-12 pt-4">
                <div class="col-12 pt-0 text-center">
                    <em class="fal fa-folder-open icon fsi" />
                    <span class="tsubhead-footer">
                    No se han encontrado resultados.
                    </span>
                </div>
                </div>
            </div>
            <div v-if="showPagination" class="row">
              <match-media v-slot="{ mobile }">
                <div v-if="!mobile" class="col-1 pt-3">
                  <custom-drop-down
                    v-model="data.selectedPaging"
                    :clearable="false"
                    fieldkey="id"
                    fieldname="name"
                    :options="pagingList"
                    @input="$emit('on-selected-paging', Number($event.id))"
                  />
                </div>
              </match-media>

              <div class="col-11">
                            
                <pagination                            
                  :data="data.pagination"                                
                  show-text
                  @pagination-go-page="$emit('on-change-page', $event)"
                />    
                                             
            </div>
          </div>                    
        </div>
</template>
<script>
import FilterManager from 'FilterManager'
import SectionTitle from 'SectionTitle';
import Pagination from "pagination";
import CustomDropDown from 'custom-drop-down';
import { MatchMedia } from 'vue-component-media-queries';
import CollapsibleSection from '@/components/common/CollapsibleSection.vue';

export default {
  name: "DetailSnapshot",
  components: {
    FilterManager,    
    SectionTitle,    
    Pagination,
    CustomDropDown,
    MatchMedia,
    CollapsibleSection        
  },  
  props: {   
    title:{
      type: String,
      default: () => ''
    },
    filters:{
      type: Object,
      default: () => {}
    },
    filterManagerConfig: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => ({
        result: {},
        pagination: {},
        selectedPaging: null
      }),
    },
    pagingList: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: () => 10,
    },
    pageSizeMobile: {
      type: Number,
      default: () => 10,
    },    
  },  
  computed: {   
    showPagination() {    
      return (       
        this.data.result.length > 0 &&
        this.data.pagination.totalItemCount > this.data.pagination.pageSize
      );
    },         
  } 
};
</script>
<style scoped src="@/assets/css/custom-style.css"></style>
<style lang="scss" scoped>
.fsi {
    font-size: 36px;
    color: #cdcdcd;
}
.tsubhead-footer {
    color: #c9c9c9;
    font-size: 15px;
}
@media only screen and (min-width: 768px) {
  ::v-deep .btn-md-process{        
    bottom: -33px !important;
    right: 15px !important;   
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;    
  }
}
</style>